<template>
    <tr v-if="row">
        <td>
            <input type="hidden" name="id" :value="row.id" />
            <i class="cus-lock mr-0" v-if="row.status == 1"></i>
            <note-link :note="row" :text="titleText"></note-link>
        </td>
        <td>{{ row.date ? _carbonDateTimeDisplay(row.date) : "" }}</td>
        <td>
            <loader-list v-if="isLoadSummary"></loader-list>
            <html-content
                v-else
                :content="summary"
                :expanded="contentExpanded"
                :isReplaceNewLine="true"
                more-text="View more"
                @onClickSeeMore="$emit('expand', row.id)"
                @onClickSeeLess="$emit('expand', null)"
                :max-width="800"
            >
                <!-- this part is now a child to html-content component -->
                <div v-if="row.active_diagnoses.length > 0">
                    <strong>Diagnoses: </strong>
                    <span v-if="_hasAccess('patient.record.update')">
                        <b
                            v-for="(diagnosis, i) in row.active_diagnoses"
                            :key="diagnosis.id"
                            @click="$emit('edit-diagnosis', diagnosis)"
                            class="text-primary cursor-pointer"
                            >{{ diagnosis.description }}
                            <span v-if="i != row.active_diagnoses.length - 1"
                                >,
                            </span>
                        </b>
                    </span>
                    <span v-else>
                        <b
                            v-for="(diagnosis, i) in row.active_diagnoses"
                            :key="'activeDiagnosis' + diagnosis.id"
                            >{{ diagnosis.description }}

                            <span v-if="i != row.active_diagnoses.length - 1"
                                >,
                            </span>
                        </b>
                    </span>
                </div>
            </html-content>
        </td>
        <td><!-- soap --></td>
        <td>
            <div v-if="row.prescribed_by && row.prescribed_by.display_name">
                {{ row.prescribed_by.display_name }}
            </div>
            <div
                v-if="
                    row.business &&
                    row.prescribed_by &&
                    row.prescribed_by.display_name &&
                    !isEditable
                "
            >
                ({{ row.business.name }})
            </div>
            <div
                v-if="
                    row.prescribed_by_default_provider &&
                    row.default_provider &&
                    row.default_provider.display_name
                "
            >
                {{ row.default_provider.display_name }}
            </div>
        </td>
        <td>
            <div v-if="(type == 'note' || type == 'all') && row.update_by">
                {{ row.update_by.display_name }}
            </div>
            <div v-else-if="type == 'record' && row.create_by">
                {{ row.create_by.display_name }}
            </div>
            <div v-if="row.business && !isEditable">
                ({{ row.business.name }})
            </div>
        </td>
        <td><!-- invoice --></td>
        <td class="text-right">
            <template v-if="isEditable">
                <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    lazy
                    v-if="
                        row.status == 0 &&
                        (_hasAccess('patient.record.update') ||
                            _hasAccess('patient.record.soap.delete') ||
                            _hasAccess('patient.record.create'))
                    "
                    right
                >
                    <template v-slot:button-content>
                        <i class="cus-cog-down"></i>
                    </template>

                    <b-dropdown-item
                        href="#"
                        @click="$emit('edit')"
                        v-if="_hasAccess('patient.record.update')"
                    >
                        <i class="cus-page-white-edit"></i>
                        Edit Note
                    </b-dropdown-item>
                    <b-dropdown-item
                        href="#"
                        @click="$emit('duplicatenote')"
                        v-if="_hasAccess('patient.record.create')"
                    >
                        <i class="cus-page-copy"></i>
                        Duplicate Note
                    </b-dropdown-item>
                    <b-dropdown-item
                        href="#"
                        @click="$emit('delete')"
                        v-if="_hasAccess('patient.record.soap.delete')"
                    >
                        <i class="cus-delete"></i>
                        Delete Note
                    </b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    lazy
                    v-else-if="
                        row.status != 0 && _hasAccess('patient.record.update')
                    "
                    right
                >
                    <template v-slot:button-content>
                        <i class="cus-cog-down"></i>
                    </template>
                    <b-dropdown-item
                        href="#"
                        @click="$emit('edit')"
                        v-if="_hasAccess('patient.record.update')"
                    >
                        <i class="cus-page-white-edit"></i>
                        View Note
                    </b-dropdown-item>
                    <b-dropdown-item
                        href="#"
                        @click="$emit('duplicatenote')"
                        v-if="_hasAccess('patient.record.create')"
                    >
                        <i class="cus-page-copy"></i>
                        Duplicate Note
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </td>
    </tr>
</template>
<script>
import HtmlContent from "@/components/commons/html-content";
import Records from "@/services/records.js";

export default {
    components: {
        HtmlContent,
        NoteLink: () => import("@/components/commons/medical-note-link"),
        LoaderList: () => import("@/components/elements/loader-list")
    },
    props: {
        row: {
            type: Object,
            default: null
        },
        contentExpanded: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoadSummary: false
        };
    },
    computed: {
        acute() {
            return this.row.is_acute ? "Acute" : "Chronic";
        },
        titleText() {
            if (this.row.title !== null && this.row.title.trim() != "") {
                const titleDate = this.row.date
                    ? this._carbonDateDisplay(this.row.date)
                    : "";
                return `${this.row.title}(${titleDate})`;
            }
            return null;
        },
        status() {
            if (this.row.status == 1) {
                return "Differential";
            } else if (this.row.status == 2) {
                return "Definitive";
            }

            return "";
        },
        isEditable() {
            return (
                this.row.business &&
                this.row.business.id === this._setting.business_id
            );
        },
        summary() {
            return this.row.summary == null ? "" : this.row.summary;
        }
    },
    mounted() {
        // TYPE NOTE ALWAYS HAS SUMMARY FROM API
        if (this.type != "note") {
            this.fetchSummary(this.row);
        }
    },
    methods: {
        fetchSummary() {
            let self = this;
            self.isLoadSummary = true;
            Records.getNoteSummary(self.row.patient_id, self.row.id)
                .then(response => {
                    if (response && response.message.code == 200) {
                        self.row.summary = response.resource.summary;
                        self.isLoadSummary = false;
                    }
                })
                .catch(error => {
                    self._message(
                        "Error : Unable to load medical note summary ",
                        "danger"
                    );
                    self.isLoadSummary = false;
                });
        }
    }
};
</script>
